import React, { useState } from 'react';
import { Stack, TextField } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { AuthForm } from '../../components/Auth/AuthForm';
import { Fields } from '@pv/common/components';

export const SignupForm = ({ afterSubmit }: { afterSubmit: () => void }) => {
  const { signUp, error } = useAuth();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await signUp({
      firstName,
      lastName,
      phone,
      email,
      password,
      passwordConfirmation,
    });
    afterSubmit();
  };

  return (
    <AuthForm
      title="Sign Up"
      onSubmit={handleSubmit}
      submitLabel="Sign Up"
      error={error}
    >
      <Stack direction="row" spacing={2}>
        <TextField
          label="First Name"
          name="first_name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
          fullWidth
        />
        <TextField
          label="Last Name"
          name="last_name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
          fullWidth
        />
      </Stack>
      <Fields.PvPhoneField
        label="Phone"
        name="phone"
        value={phone}
        onChange={(e: any) => setPhone(e.target.value)}
        required
        fullWidth
      />
      <TextField
        label="Email"
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        fullWidth
        autoComplete="email"
      />
      <TextField
        label="Password"
        type="password"
        name="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        fullWidth
        autoComplete="new-password"
        helperText="Must be at least 6 characters"
      />
      <TextField
        label="Confirm Password"
        type="password"
        name="password_confirmation"
        value={passwordConfirmation}
        onChange={(e) => setPasswordConfirmation(e.target.value)}
        required
        fullWidth
        autoComplete="new-password"
      />
    </AuthForm>
  );
};
